export enum EEmployeeStatus {
    ACTIVE = 1,
    INACTIVE = 2,
}

export enum ERelativeTypes {
    PARTNER = 1,
    FATHER = 2,
    MOTHER = 3,
    BROTHER_SISTER = 4,
    SON_DAUGHTER = 5,
    FRIEND = 6,
    OTHER = 7,
}
